const addPageNumberParamToUrl = (pageNumber, url) => {
  const newUrl = new URL(url)
  if (newUrl.searchParams.has('page')) {
    newUrl.searchParams.set('page', pageNumber)
  } else {
    newUrl.searchParams.append('page', pageNumber)
  }
  return newUrl.toString()
}

const getChildElArray = (parent) => parent ? [...parent.children] : []


const initLoadMore = (cb) => {

  const container = document.querySelector('[data-products-container]');
  if (!container) {
    return false
  }
  const theObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(async ({ target, isIntersecting }) => {
      if (isIntersecting) {
        //get the product list
        const targetList = target.parentNode;
        //get the page number from the product list
        const pageNumber = parseInt(targetList.dataset.pageNumber);
        //add the page number to current query string
        const url = addPageNumberParamToUrl(pageNumber, window.location.href)
        //get the page direction, eg we going up or down?
        const direction = targetList.dataset.pageDirection;

        if (window.location.href.includes(url) || targetList.classList.contains('loading')) {
          //if we are already on the page we have scrolled to OR we are loading that page, do nothing
          return;
        }

        //otherwise, replace history state with the new page scrolled to
        window.history.replaceState({ ...history.state }, '', url)

        if (targetList.classList.contains('loaded')) {
          //if content is already loaded in that page, do nothing
          return;
        }

        //start loading new page content in the placeholder div
        targetList.classList.add('loading')

        //fetch the HTML of the page being loaded
        const getFullPage = (typeof window.Cloud_Search !== 'undefined')
        const reqUrl = getFullPage ? url : `${url}&section_id=collection-products`;
        const res = await fetch(reqUrl);
        const body = await res.text();

        //create a new div and inject the new page HTML
        const newProductSection = document.createElement('div');
        newProductSection.innerHTML = body;

        //get the container for the products of the page being loaded
        const newList = newProductSection.querySelector('[data-products-list]');
        const newListInner = newList.querySelector(`[data-page-number="${pageNumber}"]`)

        //from the new page, next the HTML for the following page placeholder, if exists
        const nextList = newList.querySelector(`[data-page-number="${pageNumber + 1}"]`)

        if (direction === 'next') {
          //if we are going forward -->
          //remove the placholder
          targetList.parentNode.removeChild(targetList);
          //insert the new list
          container.insertBefore(newList, null)
          //add loaded class
          newListInner.classList.add('loaded')
          //added Reviews.io app logic for infinite loading 
          if (window?.ratingSnippet) {
            window.ratingSnippet(window.ratingSnippetGlobalSettings.class, window.ratingSnippetGlobalSettings.options);
          }
          //add new product cards to the instersection observer
          const newTargets = [nextList, newListInner].flatMap(getChildElArray)
          newTargets.forEach(newTarget => observer.observe(newTarget))
        } else if (direction === 'prev') {
          //if we are going backwards <---
          //inject new HTML into placeholder list, replacing the placeholders
          targetList.innerHTML = newListInner.innerHTML
          //remove loading and add loaded
          targetList.classList.remove('loading')
          targetList.classList.add('loaded')
          //add new product cards to the instersection observer
          getChildElArray(targetList).forEach(newTarget => observer.observe(newTarget))          
        } else {
          //no direction specified, do nothing
          return;
        }
        //if there is a callback, call it now
        if (cb) cb();
      }
    })
  }, {
    rootMargin: '0px',
    threshold: [0.5] // half any product card
  });

  const targetWrappers = container.querySelectorAll('[data-page-number]')
  const targetCards = [...targetWrappers].flatMap(getChildElArray);
  targetCards.forEach(target => {
    theObserver.observe(target)
  })
  
};

export default initLoadMore;
